/** The Spanish catalogue for what each key does — the wording only. Why each entry exists is argued in `en/keys.ts`. */
export default {
  group_move: 'MOVIMIENTO',
  group_fight: 'COMBATE',
  group_screen: 'PANTALLA',
  group_instrument: 'INSTRUMENTOS',
  group_drone: 'DRON',
  group_radio: 'RADIO',

  walk: 'caminar',
  run: 'correr',
  stealth: 'sigilo: media velocidad, sin pasos',
  jump: 'saltar',
  climb: 'trepar',
  kneel: 'agacharse',
  prone: 'cuerpo a tierra',
  cover_next: 'cobertura vecina (modo bounds)',

  drone_carry: 'sacar el dron: el ojo pasa a la aeronave y tu cuerpo se queda parado',
  drone_fly: 'volar: adelante, atrás y de costado',
  drone_lift: 'subir y bajar',
  drone_fast: 'a fondo; sin mantenerlo, media envolvente',
  drone_stow: 'volver al cuerpo: hay que POSARLO al lado tuyo primero',
  drone_cut: 'cortar el enlace: el dron queda POSADO donde está y vuelves a tu cuerpo sin él',

  fire: 'disparar; con la lata, lanzarla',
  grenade: 'sacar o guardar la lata de humo',
  carry: 'elegir qué llevas en las manos',
  carry_digits: '1 primaria · 2 secundaria · 3+ una lata por color',
  // El anillo de lo que se lleva encima, que en el telefono es el abanico de la mochila. La tecla dice
  // que se ABRE y la rueda que se GIRA, porque son dos actos y el que abre no elige nada.
  items: 'abrir la mochila — la rueda elige y el clic usa',
  items_digits: 'con la mochila abierta, un número elige y usa la parada',
  reload: 'recargar',
  swap: 'pasar a la secundaria y volver',
  fire_mode: 'modo de fuego: automático o disparo a disparo',
  dye: 'con la lata en la mano, el color del humo',
  tune: 'ajustar velocidad, gramaje y hop',
  scope: 'mira, mantenido (solo con tubo)',
  turret: 'torreta, dentro de la mira',
  zoom_cycle: 'aumento (cicla)',
  zoom_direct: 'aumento directo',
  zoom_direct_if: 'aumento directo, si el tubo lo trae',
  recentre: 'recentrar la mira',
  radio_bank: 'abrir el aparato: sus dieciséis memorias, A y B',
  radio_pick: 'en el banco: elegir memoria',
  radio_put: 'en el banco: poner esa memoria en A o en B',
  radio_program: 'en el banco: seis dígitos graban la frecuencia',
  radio_ab: 'cambia cuál de las dos memorias transmite',
  talk: 'transmitir por la radio; la boca queda siempre abierta',

  record_note: 'qué acaba de pasar: los últimos 12 s',
  dev_note: 'DESARROLLO — solo con el panel (F1) abierto',
  group_dial: 'CALIBRACIÓN — con el panel (F1) y su caja abierta',
  dial_ring: 'qué se calibra: la mano o cada agarre',
  dial_take: 'tomar/soltar el objeto del campo que mira la mira',
  round_start: 'empezar una ronda nueva',
  reset_targets: 'resetear las dianas',
  takeoff: 'despegue ahora',
  landing: 'aterrizaje ahora',
  stock: 'culata, con la punta fija',
  keyboard: 'este teclado',
  map: 'mapa del campo',
  release_pointer: 'soltar el puntero',
  close_tab: 'cerrar la pestaña; jugando pregunta antes',

  panel: 'panel de instrumentos',
  panel_tab: 'cambiar de pestaña del panel',
  third_person: 'verse a uno mismo desde atrás',
  record: 'grabar telemetría (corta sola a los 5 min)',

  // ── the drawn board's own chrome ──────────────────────────────────────────────────────────────────
  click_left: 'CLIC IZQ',
  click_right: 'CLIC DER',
  mouse_move: 'MOVER',
  mouse_aim: 'apuntar',
  board_close: 'T · ESC · ✕ para cerrar — cualquiera de las tres · pasa el mouse sobre una tecla para leerla',
};
